<template>
  <div>
    <el-card shadow="always" style="margin-bottom: 8px">
      <el-button
        type="success"
        style="margin-right: 8px"
        @click="openLogisticDialog"
        >菜鸟名单编辑</el-button
      ><span>已开启：{{ nameStrForEnabledLogistic || "--" }}</span>
      <div style="margin-top: 8px">
        * 不启用菜鸟联通判断的快递公司，会采用ERP【物流联通表】作为判断依据。
      </div>
    </el-card>
    <el-dialog
      title="关闭/开启 菜鸟物流联通性设置"
      :visible.sync="dialogLogisticQueryVisible"
      width="30%"
      @close="handleClose"
    >
      <el-table :data="logisticDataToModify" style="width: 100%">
        <el-table-column prop="shipping_company" label="快递公司">
        </el-table-column>
        <el-table-column prop="is_open" label="开启/关闭">
          <template slot-scope="scope">
            <el-popover
              placement="top"
              title=""
              width=""
              trigger="hover"
              content="菜鸟暂不支持查询丰网的物流轨迹"
              :disabled="scope.row.shipping_company !== '丰网速运'"
            >
              <el-switch
                slot="reference"
                v-model="scope.row.is_open"
                active-color="#13ce66"
                inactive-color="#ff4949"
                :active-value="1"
                :inactive-value="0"
                :disabled="scope.row.shipping_company === '丰网速运'"
              >
              </el-switch>
            </el-popover>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogLogisticQueryVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveLogisticData"> 确 定</el-button>
      </span>
    </el-dialog>
    <ys-data-table
      v-model="refresh"
      :list="searchList"
      :button-list="buttonList"
      :columns="columns"
      :fetch-method="fetchMethod"
      :transform-params="handleFormatSearch"
      page-size-alias="pageSize"
      :page-sizes="[100, 200, 300, 400, 1000]"
      :page-size="100"
      use-data-field
      @selection-change="handleAreaSelectionChange"
    >
      <template slot="delivery">
        <el-upload
          ref="pickingUpload"
          :show-file-list="false"
          :data="{ origin_id: originId }"
          :auto-upload="true"
          :limit="1"
          :on-success="handleSuccess"
          :on-error="handleError"
          :before-upload="handleBeforeUpload"
          :disabled="loadingUpload"
          name="excel"
          :action="action1"
          accept=".csv, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          with-credentials
        >
          <el-button slot="trigger" :loading="loadingUpload" type="primary">
            物流联通表导入</el-button
          >
        </el-upload>
      </template>
    </ys-data-table>
    <el-dialog
      title="批量停发/启用："
      :visible.sync="dialogVisible"
      width="400px"
      @close="handleDialogClose"
    >
      <el-form>
        <el-form-item label="快递公司名称:" required>
          <el-select
            v-model="selectedShippingCompany"
            multiple
            style="width: 230px"
            placeholder="快递公司"
          >
            <el-option
              v-for="item in shippingCompanyOptions"
              :key="item.cpid"
              :label="item.shipping_company"
              :value="item.cpid"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleSubmit(START_USING)">
          启用</el-button
        >
        <el-button type="danger" @click="handleSubmit(BLOCK_UP)">
          停发</el-button
        >
      </span>
    </el-dialog>
    <!--<el-dialog-->
    <!--  title="快递100联通表导出"-->
    <!--  :visible.sync="downloadDialogVisible"-->
    <!--  width="400px"-->
    <!--  @close="handleDownloadDialogClose"-->
    <!--&gt;-->
    <!--  <el-form ref="refDownloadDialog" :rules="rules" :model="ruleForm">-->
    <!--    <el-form-item label="查询日期" prop="selectData">-->
    <!--      <el-date-picker-->
    <!--        v-model="ruleForm.selectData"-->
    <!--        type="date"-->
    <!--        placeholder="请选择查询日期"-->
    <!--      >-->
    <!--      </el-date-picker>-->
    <!--    </el-form-item>-->
    <!--  </el-form>-->

    <!--  <span slot="footer" class="dialog-footer">-->
    <!--    <el-button type="primary" @click="handleExport"> 导出</el-button>-->
    <!--    <el-button type="danger" @click="downloadDialogVisible = false">-->
    <!--      取消</el-button-->
    <!--    >-->
    <!--  </span>-->
    <!--</el-dialog>-->
    <!--<el-dialog-->
    <!--  title="快递100预收运费导出"-->
    <!--  :visible.sync="downloadDialogAdvancesReceivedVisible"-->
    <!--  width="400px"-->
    <!--  @close="handleDownloadDialogAdvancesReceivedClose"-->
    <!--&gt;-->
    <!--  <el-form-->
    <!--    ref="refDownloadDialogAdvanceReceived"-->
    <!--    :rules="rules"-->
    <!--    :model="ruleForm"-->
    <!--  >-->
    <!--    <el-form-item label="查询日期" prop="selectData">-->
    <!--      <el-date-picker-->
    <!--        v-model="ruleForm.selectData"-->
    <!--        type="date"-->
    <!--        placeholder="请选择查询日期"-->
    <!--      >-->
    <!--      </el-date-picker>-->
    <!--    </el-form-item>-->
    <!--  </el-form>-->

    <!--  <span slot="footer" class="dialog-footer">-->
    <!--    <el-button type="primary" @click="handleExportAdvancesReceived">-->
    <!--      导出</el-button-->
    <!--    >-->
    <!--    <el-button-->
    <!--      type="danger"-->
    <!--      @click="downloadDialogAdvancesReceivedVisible = false"-->
    <!--    >-->
    <!--      取消</el-button-->
    <!--    >-->
    <!--  </span>-->
    <!--</el-dialog>-->

    <!--<el-dialog-->
    <!--  title="导入波次单查询快递100连通性"-->
    <!--  :visible.sync="connectShow"-->
    <!--  width="500px"-->
    <!--&gt;-->
    <!--  <el-form>-->
    <!--    <el-form-item label="波次单：">-->
    <!--      <el-upload-->
    <!--        ref="pickingUpload"-->
    <!--        :show-file-list="false"-->
    <!--        :data="{}"-->
    <!--        :auto-upload="true"-->
    <!--        :limit="1"-->
    <!--        :on-success="handleSuccess"-->
    <!--        :on-error="handleError"-->
    <!--        :before-upload="handleBeforeUpload"-->
    <!--        :disabled="loadingUpload"-->
    <!--        name="excel"-->
    <!--        :action="action2"-->
    <!--        accept=".csv, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"-->
    <!--        with-credentials-->
    <!--      >-->
    <!--        <el-button slot="trigger" :loading="loadingUpload" type="success">-->
    <!--          导入</el-button-->
    <!--        >-->
    <!--      </el-upload>-->
    <!--    </el-form-item>-->
    <!--  </el-form>-->
    <!--  <div style="text-align: right">-->
    <!--    <el-button @click="connectShow = false">取消</el-button>-->
    <!--    <el-button type="primary" @click="handleExportComputedRecord">-->
    <!--      导出最近计算完毕的记录</el-button-->
    <!--    >-->
    <!--  </div>-->
    <!--</el-dialog>-->

    <el-dialog
      title="导出联通性效果对比导出"
      :visible.sync="exportCNResultLogShow"
      width="400px"
      @close="handleExportCNResultLogShowClose"
    >
      <el-form
        ref="refDownloadDialogAdvanceReceived"
        :rules="rules"
        :model="ruleForm"
      >
        <el-form-item label="查询日期" prop="selectData">
          <el-date-picker
            v-model="ruleForm.selectData"
            type="date"
            placeholder="请选择查询日期"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleExportCNResultLog">
          导出</el-button
        >
        <el-button type="danger" @click="exportCNResultLogShow = false">
          取消</el-button
        >
      </span>
    </el-dialog>

    <ChangeLogDialog
      v-model="changeLogShow"
      :origin-id="originId"
      type="connect"
    />
  </div>
</template>

<script>
import { cloneDeep } from "lodash-es";
import dayjs from "dayjs";
import apiBaseURL from "@/utils/baseUrl.js";
import {
  getWavePickingShippingConnectList,
  getShippingAreaList,
  getWavePickingBaseShippingCompany,
  setShippingCompanyEnable,
  setShippingCompanyDisable,
} from "@/controller/wavePickingShipping.js";
import * as expressOptimizationApi from "@/controller/expressOptimization3041.js";
import ChangeLogDialog from "./ChangeLogDialog.vue";
import { downloadByUrl } from "@/utils/export.js";

const START_USING = "启用";
const BLOCK_UP = "停发";
export default {
  name: "ShippingConnectList",
  components: { ChangeLogDialog },
  props: {
    originId: {
      type: [String, Number],
      default: "",
    },
  },
  data() {
    return {
      START_USING,
      BLOCK_UP,
      // connectShow: false,
      changeLogShow: false,
      region_id: [],
      mergeForm: {
        origin_id: 1,
      },
      columns: [
        {
          type: "selection",
          width: "55",
        },
        {
          label: "省/市/区（县）",
          prop: "whole_name",
        },
        {
          label: "更新人",
          prop: "update_admin",
        },
        {
          label: "更新时间",
          prop: "updated_at",
        },
      ],
      dialogVisible: false,
      // fetchMethod() {
      //   return new Promise((resolve) => {
      //     resolve([]);
      //   });
      // },
      fetchMethod: getWavePickingShippingConnectList,
      buttonList: [
        {
          tag: "button",
          text: "导出",
          props: {
            type: "success",
          },
          event: {
            handler: (params) =>
              getWavePickingShippingConnectList({ ...params, is_excel: "1" }),
            success: (res) => window.open(apiBaseURL + res.file),
          },
        },
        {
          tag: "button",
          text: "批量启用/停发",
          props: {
            type: "primary",
          },
          event: {
            handler: () => {
              if (this.areaSelection.length === 0) {
                this.$message({
                  message: "请先选择地区",
                  type: "warning",
                  duration: 2000,
                });
              } else {
                this.dialogVisible = true;
              }
            },
          },
        },
        {
          tag: "custom",
          slot: "delivery",
        },
        // {
        //   tag: "button",
        //   text: "快递100联通表导出",
        //   props: {
        //     type: "success",
        //   },
        //   event: {
        //     handler: () => {
        //       this.downloadDialogVisible = true;
        //     },
        //   },
        // },
        {
          tag: "button",
          text: "修改日志",
          props: {
            type: "primary",
          },
          event: {
            handler: () => {
              this.changeLogShow = true;
            },
          },
        },
        // {
        //   tag: "button",
        //   text: "导入波次单查询快递100连通性",
        //   props: {
        //     type: "primary",
        //   },
        //   event: {
        //     handler: () => {
        //       this.connectShow = true;
        //     },
        //   },
        // },
        // {
        //   tag: "button",
        //   text: "快递100预收运费导出",
        //   props: {
        //     type: "success",
        //   },
        //   event: {
        //     handler: () => {
        //       this.downloadDialogAdvancesReceivedVisible = true;
        //     },
        //   },
        // },
        {
          tag: "button",
          text: "导出联通性效果对比",
          props: {
            type: "success",
          },
          event: {
            handler: () => {
              this.exportCNResultLogShow = true;
            },
          },
        },
      ],
      searchList: [
        {
          tag: "cascader",
          field: "areaArr",
          props: {
            options: [],
            placeholder: "省/市/区（县)",
            props: {
              value: "value_id",
              label: "value_name",
              children: "child",
              multiple: true,
            },
          },
        },
      ],
      areaSelection: [], // 已选地区
      refresh: false,
      selectedShippingCompany: [], // 已选快递公司
      shippingCompanyOptions: [], // 快递公司下拉框
      loadingUpload: false,
      dialogLogisticQueryVisible: false,
      logisticData: [],
      logisticDataToModify: [],
      // downloadDialogVisible: false,
      // downloadDialogAdvancesReceivedVisible: false, // 快递100预收运费导出
      exportCNResultLogShow: false, // 导出联通性效果对比
      selectData: "",
      rules: {
        selectData: [
          {
            type: "date",
            required: true,
            message: "请选择日期",
            trigger: "change",
          },
        ],
      },
      ruleForm: {
        selectData: null,
      },
      action1: `${apiBaseURL}/erp/WavePickingShipping/importWavePickingShippingConnect`,
      action2: `${apiBaseURL}/erp/WavePickingShipping/setShippingCompany100Task`,
    };
  },
  computed: {
    idStrForEnabledLogistic() {
      return this.logisticDataToModify
        .filter((logistic) => logistic.is_open === 1)
        .map((logistic) => logistic.cpid)
        .join(",");
    },
    nameStrForEnabledLogistic() {
      return this.logisticData
        .filter((logistic) => logistic.is_open === 1)
        .map((logistic) => logistic.shipping_company)
        .join("，");
    },
  },
  watch: {
    originId(val) {
      this.mergeForm.origin_id = val;
      this.refresh = true;
      this.getLogisticList();
    },
  },
  created() {
    this.mergeForm.origin_id = this.originId;
    this.getColumns();
    this.getAreaOptions();
    this.refresh = true;
    this.getLogisticList();
  },
  methods: {
    handleFormatSearch(params) {
      let regionId = [];
      if (Array.isArray(params?.areaArr)) {
        regionId = params.areaArr.map((item) => {
          return item[2];
        });
      }
      const result = {
        ...this.mergeForm,
        ...params,
        region_id: regionId,
      };
      delete result.areaArr;
      return result;
    },
    // 获取省市区下拉框
    getAreaOptions() {
      getShippingAreaList().then((data) => {
        const { list } = data;
        this.searchList[0].props.options = list;
      });
    },
    // 获取所有快递公司表头
    getColumns() {
      getWavePickingBaseShippingCompany().then((data) => {
        this.shippingCompanyOptions = data;
        const columnsArr = data.map((item) => {
          return {
            label: item.shipping_company,
            prop: item.table_pre,
          };
        });
        const columnsClone = cloneDeep(this.columns);
        columnsClone.splice(2, 0, ...columnsArr);
        this.columns = columnsClone;
      });
    },
    handleAreaSelectionChange(selection) {
      this.areaSelection = selection;
    },
    // 批量启用/停用
    handleSubmit(type) {
      const { areaSelection, selectedShippingCompany } = this;
      if (selectedShippingCompany.length === 0) {
        this.$message.error("请选择快递公司");
        return;
      }
      const companyArr = [];
      this.selectedShippingCompany.forEach((element) => {
        companyArr.push(
          this.shippingCompanyOptions.find((item) => item.cpid === element)
            .shipping_company
        );
      });
      this.$confirm(
        `确认对所勾选的地区${type}${companyArr.join(" ")}快递？`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          const API =
            type === START_USING
              ? setShippingCompanyEnable
              : setShippingCompanyDisable;
          const params = {
            region_ids: areaSelection
              .map((item) => item.area_region_id)
              .join(","),
            origin_id: this.mergeForm.origin_id,
            cpid: selectedShippingCompany.join(","),
          };
          API(params).then(() => {
            this.$message.success(`${type}成功`);
            this.handleDialogClose();
            this.refresh = true;
          });
        })
        .catch((err) => {
          console.log(err.msg);
        });
    },
    handleDialogClose() {
      this.dialogVisible = false;
      this.selectedShippingCompany = [];
    },
    handleSuccess(res) {
      this.$refs.pickingUpload.clearFiles();
      this.loadingUpload = false;
      if (res.code !== 200) {
        this.$message.error(res.msg);
      } else if (res.data.file) {
        this.$message.error("导入失败");
        downloadByUrl(res.data.file);
      } else {
        this.$message.success("导入成功");
        this.refresh = true;
      }
    },
    handleError() {
      this.$refs.pickingUpload.clearFiles();
      this.loadingUpload = false;
      // this.$message.error(err);
      this.$message.error("导入失败");
    },
    handleBeforeUpload(file) {
      console.log("file", file);
      const suffixList = [".csv", ".xlsx", ".xls"];
      const isExcel = suffixList.some((suffix) => file.name.endsWith(suffix));
      if (!isExcel) {
        this.$message.info(
          `文件类型错误，请重新选择，仅支持${suffixList.join(",")}格式`
        );
        return;
      }
      this.loadingUpload = true;
    },
    openLogisticDialog() {
      this.dialogLogisticQueryVisible = true;
    },
    getLogisticList() {
      expressOptimizationApi
        .getShippingCompanyCheck({ stock_storehouse_id: this.originId })
        .then((res) => {
          this.logisticData = res.list;
          this.logisticDataToModify = cloneDeep(this.logisticData);
        });
    },
    handleClose() {
      this.dialogLogisticQueryVisible = false;
      this.logisticDataToModify = cloneDeep(this.logisticData);
    },
    saveLogisticData() {
      const params = {
        stock_storehouse_id: this.originId,
        cpids: this.idStrForEnabledLogistic,
      };
      expressOptimizationApi.setShippingCompanyCheck(params).then((res) => {
        this.$message.success("设置成功");
        this.logisticData = res.list;
        this.dialogLogisticQueryVisible = false;
      });
    },
    handleExport() {
      this.$refs.refDownloadDialog.validate((valid) => {
        if (valid) {
          const params = {
            stock_storehouse_id: this.originId,
            selectData: parseInt(
              this.ruleForm.selectData.getTime() / 1000,
              10
            ).toString(),
          };
          expressOptimizationApi.exportExpress100Log(params).then((res) => {
            this.$message.success("导出成功");
            window.open(apiBaseURL + res.file);
          });
        }
      });
    },
    handleExportCNResultLog() {
      this.$refs.refDownloadDialogAdvanceReceived.validate((valid) => {
        if (valid) {
          const params = {
            origin: this.originId,
            create_data: dayjs(this.ruleForm.selectData).format("YYYYMMDD"),
          };
          expressOptimizationApi.exportCnResultLog(params).then((url) => {
            this.$message.success("导出成功");
            window.open(apiBaseURL + url);
          });
        }
      });
    },
    // handleExportAdvancesReceived() {
    //   console.log("selectData", this.ruleForm.selectData);
    //   this.$refs.refDownloadDialogAdvanceReceived.validate((valid) => {
    //     if (valid) {
    //       const params = {
    //         out_time: dayjs(this.ruleForm.selectData).format("YYYY-MM-DD"),
    //       };
    //       expressOptimizationApi
    //         .exportKd100AdvanceFreight(params)
    //         .then((res) => {
    //           this.$message.success("导出成功");
    //
    //           window.open(apiBaseURL + res.file);
    //         });
    //     }
    //   });
    // },
    // handleDownloadDialogClose() {
    //   this.downloadDialogVisible = false;
    //   this.ruleForm = this.$options.data().ruleForm;
    //   this.$refs.refDownloadDialog.resetFields();
    // },
    // handleDownloadDialogAdvancesReceivedClose() {
    //   this.downloadDialogAdvancesReceivedVisible = false;
    //   this.ruleForm = this.$options.data().ruleForm;
    //   this.$refs.refDownloadDialogAdvanceReceived.resetFields();
    // },
    handleExportCNResultLogShowClose() {
      this.exportCNResultLogShow = false;
      this.ruleForm = this.$options.data().ruleForm;
      this.$refs.refDownloadDialogAdvanceReceived.resetFields();
    },
    // async handleExportComputedRecord() {
    //   try {
    //     const { file } =
    //       await expressOptimizationApi.getShippingCompany100TaskLog();
    //     if (file) {
    //       downloadByUrl(file);
    //     } else {
    //       this.$message.error("导出最近计算完毕的记录失败");
    //     }
    //   } catch (err) {
    //     console.log(err);
    //   }
    // },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/wavepicking/ShippingRule/components/ShippingConnectList.vue